import { useState } from 'react';

// The preference is persisted in localStorage. Default is 'barcode'.

export type DisplayFormat = 'barcode' | 'qrcode';

const STORAGE_KEY = 'scannerControl_displayFormat';

const getStoredFormat = (): DisplayFormat => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === 'qrcode' ? 'qrcode' : 'barcode';
};

export const useDisplayFormat = () => {
    const [format, setFormatState] = useState<DisplayFormat>(getStoredFormat);

    const setFormat = (newFormat: DisplayFormat) => {
        setFormatState(newFormat);
        localStorage.setItem(STORAGE_KEY, newFormat);
    };

    return { format, setFormat };
};

export default useDisplayFormat;
